import type { Product } from "@decocms/apps-commerce/types";
import ImageNameAndBuyButtonShelf from "~/components/product/ImageNameAndBuyButtonShelf";
import { Layout as CardLayout } from "~/components/product/ProductCard";

interface Props {
  sectionTitle: string;
  products: Product[] | null;
  productsPerScrollDesktop: 1 | 2 | 3 | 4 | 5 | 6;
  cardLayout?: CardLayout;
  /** @description Used for analytics event, will not appear on interface */
  title?: string;
}

function CrossSellingShelf({
  sectionTitle,
  products,
  productsPerScrollDesktop,
  cardLayout,
  title,
}: Props) {
  if (!products || !products.length) {
    return null;
  }

  return (
    <section className="w-full lg:w-[1200px] lg:container crossSellingShelfContainer mt-8 lg:mt-16">
      <p className="font-['Poppins',Helvetica,Arial,sans-serif] text-lg font-semibold text-[#333333] text-center my-8 lg:my-18 mx-auto">
        {sectionTitle}
      </p>
      <ImageNameAndBuyButtonShelf
        products={products}
        cardLayout={cardLayout}
        productsPerScrollDesktop={productsPerScrollDesktop}
        title={title}
      />
    </section>
  );
}

export default CrossSellingShelf;
